import { render, staticRenderFns } from "./ProductImagesCarousel.vue?vue&type=template&id=78db3639&"
import script from "./ProductImagesCarousel.vue?vue&type=script&lang=ts&"
export * from "./ProductImagesCarousel.vue?vue&type=script&lang=ts&"
import style0 from "./ProductImagesCarousel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports